import { createSlice } from '@reduxjs/toolkit';

const passwordChangeSlice = createSlice({
  name: 'passwordChange',
  initialState: {
    currentCheck: false, // 현 비밀번호 체크
    isSuccess: false, // 변경 상태
    encPassword: '',
    resetSubmit: false,
    isKmsUser: false,
  },
  reducers: {
    initPasswordChange: state => {
      state.currentCheck = false;
      state.isSuccess = false;
      state.encPassword = '';
      state.resetSubmit = false;
    },
    getCheckPassword: () => {},
    getCheckPasswordSuccess: (state, { payload }) => {
      state.currentCheck = payload;
    },
    getCheckPasswordFail: state => {
      state.resetSubmit = true;
    },
    setCheckPasswordSuccess: state => {
      state.currentCheck = true;
    },
    modifyPassword: () => {},
    modifyPasswordKms: () => {},
    modifyPasswordInitial: () => {},
    modifyPasswordSuccess: (state, { payload }) => {
      state.isSuccess = payload.result;
      state.encPassword = payload.encPassword;
    },
    modifyPasswordFail: state => {
      state.resetSubmit = true;
    },
  },
});

export const {
  initPasswordChange,
  getCheckPassword,
  getCheckPasswordSuccess,
  getCheckPasswordFail,
  setCheckPasswordSuccess,
  modifyPassword,
  modifyPasswordSuccess,
  modifyPasswordFail,
  modifyPasswordKms,
  modifyPasswordInitial,
} = passwordChangeSlice.actions;
export default passwordChangeSlice.reducer;
